import { z } from "zod";
import { KPI_STATUSES } from "@playbookai/types";
import { ShortText, MediumText, LongText } from "./common.js";
/**
 * Daily Brief — Player AI's morning narrative. AI-populated content registered
 * as a real `WidgetKind` (mocked today; AIS swap is drop-in per ADR-0012/0007).
 * Each highlight stores the **semantic** status via `z.enum(KPI_STATUSES)`, not
 * a colour. Rich seed content lives in the mock; `defaultParams` is a skeleton.
 */
const DailyBriefHighlightSchema = z
    .object({
    status: z.enum(KPI_STATUSES),
    text: MediumText,
})
    .strict();
export const DailyBriefParamsSchema = z
    .object({
    headline: ShortText.optional(),
    narrative: LongText.optional(),
    highlights: z.array(DailyBriefHighlightSchema).optional(),
})
    .strict();
export const defaultDailyBriefParams = { highlights: [] };
//# sourceMappingURL=dailyBrief.js.map